import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Sistem içeriği" className="bg-transparent" data-id="element-268" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-269" data-mp="18228utp09lfn">
        <div className="text-center" data-id="element-270" data-mp="1zv1nfblkz7nh">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-271" data-mp="1zw4d5g76341t">
            100+ TAKTİK RAPOR YAPAY ZEKÂ KOMUTU™ — SİSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-272" data-mp="24rs1jtdtrt69">
            📚 6 Ciltlik Taktik Raporlama Koleksiyonu
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-273" data-mp="1vs4xeztpo99i">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-274" data-mp="fe6f9xuqg9n3">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-275" data-mp="3o8f20brxnbnh">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-276" data-mp="3jawp6aasoca7" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-277" data-mp="60phy6cqxhut">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-278" data-mp="kq4zcvqe0axu">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-279" data-mp="tse9vllno4b8">
                  <span aria-hidden="true" data-id="element-280" data-mp="pru8g5u1ueja">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-281" data-mp="wrmqtt00oxnd">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-282" data-mp="16rx1p6ykxszd">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-283" data-mp="16q2hjuv4u4wc">
            ✅ Her ciltte neler bulunuyor?
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-284" data-mp="1fkqpxtw082pd">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-285" data-mp="1kj1xfxytu14f">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-286" data-mp="1piet987oeij5" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}